export const transformCoordinates = ([lng, lat]) => ({ lat, lng });
export const transformPolygonCoordinates = (coordinates) => coordinates.map(transformCoordinates);
